import React from 'react'

export default function SongListItem({currentSong,song,changeSong}) {
  return (
    <div className="song-list-item">
      <div className="song-list-image">
        <img src={song.img} alt={song.name} />
      </div>
      <div className="song-list-song-details">
        <h4>{song.name}</h4>
        <p className="muted-text">{song.artist}</p>
      </div>
      <div className="song-list-button">
        
        {currentSong.id === song.id ? (
          <button onClick={() => changeSong(song.id)}>
            <i className="bi bi-pause-circle"></i>
          </button>
        ):(
          <button onClick={() => changeSong(song.id)}>
            <i className="bi bi-play-circle"></i>
          </button>
        )}
      </div>
    </div>
  );
}
